import * as React from "react"
import "./detailed.css"
import l8 from "../../../images/l8.png"
import l9 from "../../../images/l9.png"
import l10 from "../../../images/l10.png"

const Detailed = () => {
    return (
        <>
            <section className="wrapper bg-light">
                <div className="container py-4 py-md-6 pt-md-10">
                    <div className="card bg-soft-primary">
                        <div className="card-body p-md-10 py-xxl-16 position-relative">
                            <div className="row gx-md-0 gx-xl-12 text-center">
                                <div
                                    data-sal="flip-down"
                                    data-sal-delay="200"
                                    data-sal-easing="easeInExpo"
                                    className="col-lg-5 d-flex justify-content-center"
                                >
                                    <img src={l8} alt="" width={500} height={`auto`}/>
                                </div>
                                <div
                                    data-sal="slide-left"
                                    data-sal-delay="300"
                                    data-sal-easing="easeInExpo"
                                    className="col-lg-7 col-xl-6"
                                >
                                    <span className="ratings five mb-3"/>
                                    <blockquote className="border-0 fs-lg mb-0">
                                        <p>
                                            “The standard of their service and products is very high and they always
                                            strive
                                            to make improvements to
                                            accommodate our needs and improve the quality and presentation of our
                                            finished
                                            products. The team at
                                            Texbond Nonwovens are always helpful and easy to work with and we have built
                                            up
                                            a good mutual trading
                                            relationship over the years.”
                                        </p>
                                        <div className="blockquote-details justify-content-center text-center">
                                            <div className="info p-0">
                                                <h5 className="mb-1">
                                                    Graham Elsey
                                                </h5>
                                                <div className="meta mb-0">
                                                    Growtivation
                                                </div>
                                            </div>
                                        </div>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light">
                <div className="container py-4 py-4 py-md-6 pt-md-10">
                    <div className="card bg-soft-green">
                        <div className="card-body p-md-10 py-xxl-16 position-relative">
                            <div className="row gx-md-0 gx-xl-12 text-center">
                                <div
                                    data-sal="flip-down"
                                    data-sal-delay="200"
                                    data-sal-easing="easeInExpo"
                                    className="col-lg-5 d-flex justify-content-center"
                                >
                                    <img src={l10} alt="" width={500} height={`auto`}/>
                                </div>
                                <div
                                    data-sal="slide-left"
                                    data-sal-delay="300"
                                    data-sal-easing="easeInExpo"
                                    className="col-lg-7 col-xl-6"
                                >
                                    <span className="ratings five mb-3"/>
                                    <blockquote className="border-0 fs-lg mb-0">
                                        <p>
                                            “Centuary has been doing business with Texbond since 2008.
                                            The prices are competitive and deliveries are always on time.
                                            Any technical issues raised, these are sorted out on a war footing basis.
                                            Texbond team is very supportive...
                                            ”
                                        </p>
                                        <div className="blockquote-details justify-content-center text-center">
                                            <div className="info p-0">
                                                <h5 className="mb-1">
                                                    M. Satya Subbarao
                                                </h5>
                                                <div className="meta mb-0">
                                                    Century Mattresses
                                                </div>
                                            </div>
                                        </div>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light">
                <div className="container py-4 py-md-6 pt-md-10">
                    <div className="card bg-soft-red">
                        <div className="card-body p-md-10 py-xxl-16 position-relative">
                            <div className="row gx-md-0 gx-xl-12 text-center">
                                <div
                                    data-sal="flip-down"
                                    data-sal-delay="200"
                                    data-sal-easing="easeInExpo"
                                    className="col-lg-5 d-flex justify-content-center"
                                >
                                    <img src={l9} alt="" width={500} height={`auto`}/>
                                </div>
                                <div
                                    data-sal="slide-left"
                                    data-sal-delay="300"
                                    data-sal-easing="easeInExpo"
                                    className="col-lg-7 col-xl-6"
                                >
                                    <span className="ratings five mb-3"/>
                                    <blockquote className="border-0 fs-lg mb-0">
                                        <p>
                                            “Shree Malani Foams has been doing business with Texbond since 2016.
                                            We are using Texbond nonwoven fabrics for making mattresses for our
                                            International clients.
                                            The quality up to our customer requirements which are getting passed in
                                            International testing laboratories.
                                            ”
                                        </p>
                                        <div className="blockquote-details justify-content-center text-center">
                                            <div className="info p-0">
                                                <h5 className="mb-1">
                                                    M. Satya
                                                </h5>
                                                <div className="meta mb-0">
                                                    Shree Malani Foams Pvt. Ltd.
                                                </div>
                                            </div>
                                        </div>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Detailed